<script setup>
import { computed, useSlots, provide } from 'vue';

const props = defineProps({
  activeId: {
    type: [String, Number],
    default: null,
  },
  size: {
    type: String,
    default: 'md',
    validator: value => ['xs', 'sm', 'md', 'lg'].includes(value),
  },
});

const emit = defineEmits(['click']);

const sizeClasses = {
  xs: 'px-2 py-1 text-xs',
  sm: 'px-4 py-2 text-sm',
  md: 'px-4 py-2 text-base',
  lg: 'px-8 py-4 text-lg',
};

provide('buttonGroupContext', {
  activeId: computed(() => props.activeId),
  size: computed(() => props.size),
  sizeClasses,
  onClick: (id, onClick) => {
    emit('click', { id });
    if (onClick) {
      onClick();
    }
  },
});
</script>

<template>
  <div
    class="flex items-center rounded-lg border border-n-weak overflow-hidden"
  >
    <slot />
  </div>
</template>
